import { render } from "./ezIcon.vue?vue&type=template&id=7c963f06&scoped=true"
import script from "./ezIcon.vue?vue&type=script&lang=js"
export * from "./ezIcon.vue?vue&type=script&lang=js"

import "./ezIcon.vue?vue&type=style&index=0&id=7c963f06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c963f06"]])

export default __exports__